/*
 * immutably inserts 'items' into array at index
 * 'items' are passed as rest operator arguments
 *
 * arrayInsert([ 1, 2, 3 ], 1, 'foo', 'bar') -> [ 1, 'foo', 'bar', 2, 3 ]
 */

module.exports = function arrayInsert (array, index, ...items) {
  return [
    ...array.slice(0, index),
    ...items,
    ...array.slice(index)
  ]
}
